import $ from 'jquery';
import {showFormResponse} from "../common/json-response";

function deleteHandler(e) {
  e.preventDefault();
  const button = e.currentTarget;
  const fieldUuid   = button.getAttribute('data-custom-field-uuid');
  const fieldFormat = button.getAttribute('data-custom-field-format');
  const columnUuid   = button.getAttribute('data-custom-column-uuid');
  const fieldUuidAttr = '[data-custom-field-uuid="' + fieldUuid + '"]';
  const fieldFormatAttr = '[data-custom-field-format="' + fieldFormat + '"]';
  const url = button.getAttribute('data-delete-url');
  const statusWrapper = document.querySelector('.action-status-messages');

  const data = {
    fieldUuid,
    fieldFormat,
    columnUuid
  };

  $.ajax({
    type: "POST",
    url: url,
    dataType: 'json',
    data: data,
    success: function (data) {
      if (data.redirectTo?.length) {
        window.location.href = data.redirectTo;
      }

      showFormResponse(data);

      if (data.status !== 'success') {
        return;
      }

      const columnSelector = '.custom_field_params[data-custom-field-uuid="' + fieldUuid + '"] .column_item[data-custom-column-uuid="' + columnUuid + '"]';
      const customColumn = document.querySelector(columnSelector);
      customColumn.remove();
    },
    error: function (data) {
      if (data.messages) {
        showFormResponse(data);
      } else {
        const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
        const statusMsg = document.createElement('div');
        statusMsg.classList.add(['alert']);
        statusMsg.classList.add(['alert_error']);
        statusMsg.innerHTML = message;
        statusWrapper.appendChild(statusMsg);
      }
    },
  });
};

function initDeleteCustomColumn() {
  const deleteButtons = document.querySelectorAll('.delete_custom_field_column');

  deleteButtons?.forEach(function (button) {
    button.addEventListener('click', deleteHandler);
  });
}

export {deleteHandler, initDeleteCustomColumn}